import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface NavArrowDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const NavArrowDownIcon = ({ className, ...props }: NavArrowDownIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default NavArrowDownIcon;
